"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_jss_1 = __importDefault(require("react-jss"));

exports.default = react_jss_1.default({
  loader: {
    display: 'inline-block',
    position: 'relative',
    width: '4.5em',
    height: '1em',
    '& div': {
      position: 'absolute',
      margin: 'auto',
      top: 0,
      bottom: 0,
      width: '1em',
      height: '1em',
      borderRadius: '50%',
      background: 'currentColor',
      animationTimingFunction: 'cubic-bezier(0, 1, 1, 0)'
    },
    '& div:nth-child(1)': {
      left: '0.5em',
      animation: 'lds-ellipsis1 0.6s infinite'
    },
    '& div:nth-child(2)': {
      left: '0.5em',
      animation: 'lds-ellipsis2 0.6s infinite'
    },
    '& div:nth-child(3)': {
      left: '2em',
      animation: 'lds-ellipsis3 0.6s infinite',
      zIndex: 1
    },
    '& div:nth-child(4)': {
      left: '3.5em',
      animation: 'lds-ellipsis4 0.6s infinite',
      zIndex: 0
    }
  },
  '@keyframes lds-ellipsis1': {
    '0%': {
      transform: 'scale(0)'
    },
    '100%': {
      transform: 'scale(1)'
    }
  },
  '@keyframes lds-ellipsis2': {
    '0%': {
      transform: 'translate(0, 0)'
    },
    '100%': {
      transform: 'translate(1.5em, 0)'
    }
  },
  '@keyframes lds-ellipsis3': {
    '0%': {
      transform: 'translate(0, 0)'
    },
    '100%': {
      transform: 'translate(1.5em, 0)'
    }
  },
  '@keyframes lds-ellipsis4': {
    '0%': {
      transform: 'scale(1)'
    },
    '100%': {
      transform: 'scale(0)'
    }
  }
});